import { queryBuilder } from '@inpart-io/devtools-iap';
import { RETRIEVE_BY_QUERY } from '@inpart-io/devtools-vue';
import { type IPrivateContactLead } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { RECEIVE_BY_LEAD } from './mutations';

export const STORE_BY_LEAD = 'storeByLead';
export const RETRIEVE_BY_CONTACT = 'retrieveByContact';
export const RETRIEVE_BY_CONTACT_LIST = 'retrieveByContactList';
export const RETRIEVE_BY_LEAD = 'retrieveByLead';
export const RETRIEVE_BY_CONTACT_AND_LEAD = 'retrieveByContactAndLead';

export const actions: ActionTree<IPrivateContactLead, unknown> = {
    async [RETRIEVE_BY_LEAD](context, { leadId, properties }: { leadId: number; properties?: string }): Promise<number[]> {
        const idList = await context.dispatch(RETRIEVE_BY_QUERY, {
            query: queryBuilder.build(queryBuilder.op.and(queryBuilder.cmp.refersTo('lead', leadId))),
            properties
        });
        context.commit(RECEIVE_BY_LEAD, { leadId, idList });
        return idList;
    },
    [STORE_BY_LEAD](context, { leadId, idList }: { leadId: number; idList: number[] }): void {
        context.commit(RECEIVE_BY_LEAD, { leadId, idList });
    }
};
